import { useQuery, QueryFunction } from 'react-query';
import { getAllMachinesTypes, GetMachinesTypesQueries, MachineType } from '../../services/apiSLTP/materials/machinesTypes';

type UseMachinesTypesQueryOptions = {
    queries?: GetMachinesTypesQueries;
};

const getMachinesTypes: QueryFunction<MachineType[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMachinesTypesQueryOptions];
    const { queries } = options;

    const response = await getAllMachinesTypes(queries);
    return response.data;
};

export const useMachinesTypesQuery = (options: UseMachinesTypesQueryOptions) => {
    return useQuery(['machinesTypes', options], getMachinesTypes);
};
